import { render, staticRenderFns } from "./CredentialsIssued.vue?vue&type=template&id=35f08798"
import script from "./CredentialsIssued.vue?vue&type=script&lang=js"
export * from "./CredentialsIssued.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports